$(window).on("load",(function(){ 
  setTimeout(function(){
/**/
//PLP - on add to cart click trigger quick view add to cart CTA
$(".plp-add-to-cart").on('click', function(){
    

//$(document).on('click ', '.plp-add-to-cart', function(event) {  
  //alert('1');
  console.log('yes, clicked');
 
    
if($(window).width() < 767){
    $(this).parent().find('.mobile-only-form .add-to-cart').trigger('click');
} else {
  $(".loading").fadeIn();
  
  $(this).parent().parent().find('.quick-product__btn').trigger('click');
    $(this).parent().parent().find('.quick-product__btn').css('border', '5px solid red');
     
}
    setTimeout(function(){
      console.log('next click');
      //$(this).trigger('click');
      $('.modal--is-active').find(".add-to-cart").trigger('click');
      $(".loading").fadeOut();
  }, 1500);  
});


if( /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent) ) {
$('.plp-add-to-cart').on('touchstart touchend', function() {
  $(this).parent().find('.mobile-only-form .add-to-cart').trigger('click');
});
}

    
    }, 500);  
}));


$(document).ready(function() {

  $('.footer__social').appendTo('.footer_item_follow-us')

  
var wheight = $(window).height();
$(".loading").css('height', wheight);
  



  



  
  if($(window).width() < 767){
  //$("video#Mp4Video-how-it-works").attr('poster', 'https://cdn.shopify.com/s/files/1/0581/1159/0483/t/7/assets/password-page-background.jpg')
}
  
    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav'
    });
    $('.slider-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        speed: 500,
        asNavFor: '.slider-for',
        dots: false,
       infinite: false,
         arrows:false,
        centerMode: false,
        focusOnSelect: true,
        slide: 'div'
    });

$('#Mp4Video-how-it-works').trigger('pause');
  
    });

$('body').on('click', '.show_model', function(e) {
    $(this).addClass("active");
    $('.show_product').removeClass("active");
    $('.grid__item-image-wrapper').addClass("show_img_model");  
    $('.grid__item-image-wrapper').removeClass("show_img_product");  
});
$('body').on('click', '.show_product', function(e) {
    $(this).addClass("active");
    $('.show_model').removeClass("active");
    $('.grid__item-image-wrapper').addClass("show_img_product");  
    $('.grid__item-image-wrapper').removeClass("show_img_model");  
});
$('body').on('click', '.btn-close-search', function(e) {
     $('.predictive-search').removeClass("is-active");
   $('.site-header__search-container').removeClass("is-active");
  $('body').removeClass("predictive-overflow-hidden");

});
$('body').on('click', '.header_h3', function(e) {
    $('.box-a1').find('.level-box').stop().slideUp();
    $(this).closest('.box-a1').find('.level-box').stop().slideToggle();
 $('.header_h3').not(this).removeClass("active");
  $(this).toggleClass('active')
});


$('body').on('click', '.klaviyo-bis-trigger', function(e) {
    $('body').addClass("klaviyo-popup-open");   
});

function playVideo() {
   $('#Mp4Video-how-it-workss').trigger('play');
 //  $('.hero__text-wrap').hide();
 // $('#Mp4Video-how-it-works').attr('controls', 'controls');
 $('.vid_popup').fadeIn('fast');
}
function stopVideo() {
   $('#Mp4Video-how-it-workss').trigger('pause');
 $('.vid_popup').fadeOut('fast');
}



 $(document).ready(function() {
	   	   var n1 = Math.round(Math.random() * 10 + 1);
	     	   var n2 = Math.round(Math.random() * 10 + 1);
	   	   $("#question").val(n1 + " + " + n2);
	  	   $(".contact-form").submit(function (e) {
	          	   if (eval($("#question").val()) != $("#answer").val()) {
	                     $("#answer").css('box-shadow', '0px 0px 7px red');
	              	     e.preventDefault(); 
	          	   } 
	     	   });
	    });
            


/*
$('.plp-add-to-cart').on('touchmove touchend', function(e) {
//  $(this).trigger('click');
  $(this).parent().parent().find('.quick-product__btn').trigger('click');
  setTimeout(function(){
    console.log('next click');
    $('.modal--is-active').find(".add-to-cart").trigger('click');
  }, 2000);  
});
*/